import styled from "@emotion/styled/macro";
import { colors } from "../../../../../common/styles/theme.styles";

export const StatusDropdownContainer = styled.div`
    width: 288px;
    background: #fff;
    border: 1px solid ${colors.gray3};
    border-radius: 12px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.08);
    padding: 16px 0px;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const StatusDropdownHeader = styled.div`
    padding: 0px 16px 8px;
    font-family: Circular;
    font-size: 12px;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.gray2};
`;

export const StatusDropdownBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0px 16px;
`;

export const StatusOption = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 10px;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background: #F1F3F5;
    }
`;

export const StatusCheckbox = styled.div`
    position: relative;
    width: 18px;
    height: 18px;
    flex-shrink: 0;

    input[type="checkbox"] {
        width: 18px;
        height: 18px;
        margin: 0;
        opacity: 0;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        width: 18px;
        height: 18px;
        background: transparent;
        border: 1.125px solid ${colors.gray3};
        border-radius: 5.4px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;

        svg {
            opacity: 0;
            transition: opacity 0.2s ease;
        }
    }

    input[type="checkbox"]:checked + .checkmark {
        background: ${colors.darkGray1};
        border-color: ${colors.darkGray1};

        svg {
            opacity: 1;
        }
    }
`;

export const StatusLabel = styled.div`
    font-family: Circular;
    font-size: 14px;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.darkGray1};
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const StatusDescription = styled.div`
    font-size: 12px;
    font-weight: 450;
    line-height: normal;
    color: ${colors.darkGray3};
`; 